import { gql } from '@apollo/client';

export default gql`
  query getBranchsLandingChartData {
    getBranchsLandingChartData {
      ok
      error
      message
      data
    }
  }
`;
